import { GzRmZeroTrustWidgetWebComponent } from './component/GzRmZeroTrustWidgetWebComponent';

export { GzRmZeroTrustWidgetWebComponent };
